export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_43-2098ee3616ab1d9db7da48207a54c46c.jpg";